var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenewalChannels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.412,
    height: 28.383,
    viewBox: "0 0 28.412 28.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12070",
    "data-name": "Group 12070",
    transform: "translate(-710.813 -240.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22066",
    "data-name": "Path 22066",
    d: "M832.768,362.3V373.01H843.5V362.293h-4.633c0,.573.007,1.15,0,1.726a.7.7,0,0,1-.613.691.724.724,0,0,1-.813-.495.915.915,0,0,1-.034-.27q0-1.176,0-2.352a.719.719,0,0,1,.8-.788q2.994,0,5.988,0a.714.714,0,0,1,.788.8q0,6.034,0,12.068a.725.725,0,0,1-.825.822q-6.034,0-12.068,0a.717.717,0,0,1-.794-.792q0-6.049,0-12.1a.718.718,0,0,1,.79-.8q1.528,0,3.055,0a.734.734,0,1,1,.01,1.463c-.764,0-1.528,0-2.291.005A.5.5,0,0,0,832.768,362.3Z",
    transform: "translate(-113.114 -112.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22067",
    "data-name": "Path 22067",
    d: "M733.689,243.405c-.016-.327-.04-.629-.044-.931a.714.714,0,0,1,.674-.788.692.692,0,0,1,.792.693q.106,1.37.17,2.742a.691.691,0,0,1-.67.79q-1.437.187-2.877.346a.759.759,0,0,1-.845-.624.72.72,0,0,1,.664-.826c.383-.052.766-.094,1.19-.145a1.263,1.263,0,0,0-.143-.153A12.722,12.722,0,0,0,712.419,253a12.531,12.531,0,0,0,.9,6.626c.244.585.034,1.063-.5,1.161a.757.757,0,0,1-.838-.51,14.01,14.01,0,0,1,.349-11.916,14.248,14.248,0,0,1,21.059-5.133c.067.047.131.1.2.143A.553.553,0,0,0,733.689,243.405Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22068",
    "data-name": "Path 22068",
    d: "M777.721,389.487c0,.342,0,.637,0,.931a.735.735,0,0,1-.694.807.756.756,0,0,1-.778-.767c-.044-.844-.1-1.687-.133-2.531-.029-.656.2-.9.852-.968.879-.1,1.757-.213,2.637-.3a.738.738,0,0,1,.891.658.777.777,0,0,1-.758.8c-.359.044-.719.081-1.079.12l-.039.106c.678.4,1.337.838,2.037,1.2a12.274,12.274,0,0,0,6.4,1.333,12.679,12.679,0,0,0,10.973-17.637c-.233-.559-.12-.977.315-1.165a.746.746,0,0,1,1.006.473,14.031,14.031,0,0,1,.978,3.323,13.516,13.516,0,0,1-1.321,8.651A14.252,14.252,0,0,1,778,389.668C777.916,389.612,777.832,389.56,777.721,389.487Z",
    transform: "translate(-61.309 -123.453)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalChannels);
export default __webpack_public_path__ + "static/media/Renewal_channels.8ac93b9ae223566dd7b383d351695262.svg";
export { ForwardRef as ReactComponent };